import { render } from "./SideBar.vue?vue&type=template&id=71e01c15&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=71e01c15&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71e01c15"

export default script